// Video facade functionality
import Player from '@vimeo/player';

function playVideo(button: HTMLElement, hideButton: boolean = true) {
    const section = button.closest('section');
    if (!section) return;

    // Find the iframe (Vimeo/YouTube embed) within the same section
    const iframe = section.querySelector('iframe');
    if (!iframe) return;

    const src = iframe.getAttribute('src') || '';

    // Handle Vimeo with SDK
    if (src.includes('vimeo.com')) {
        const player = new Player(iframe);
        player.play();
        if (hideButton) {
            button.style.visibility = 'hidden';
        }
    }
    // Handle YouTube with postMessage API
    else if (src.includes('youtube.com') || src.includes('youtu.be')) {
        // YouTube iframe API expects enablejsapi=1 in src
        if (!src.includes('enablejsapi=1')) {
            const newSrc = src + (src.includes('?') ? '&' : '?') + 'enablejsapi=1';
            iframe.setAttribute('src', newSrc);

            // Wait for iframe to reload
            iframe.addEventListener('load', () => {
                iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                if (hideButton) {
                    button.style.visibility = 'hidden';
                }
            }, { once: true });
        } else {
            iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            if (hideButton) {
                button.style.visibility = 'hidden';
            }
        }
    }
}

export function initVideos() {
    // Handle .play-video buttons
    const playButtons = document.querySelectorAll<HTMLElement>('.play-video');

    playButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            playVideo(button);
        });
    });

    // Handle <a> tags with "play video" text
    const playVideoLinks = document.querySelectorAll<HTMLAnchorElement>('a');

    playVideoLinks.forEach((link) => {
        const linkText = link.textContent?.trim().toLowerCase();
        if (linkText === 'play video') {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                playVideo(link, false); // Don't hide the link
            });
        }
    });
}
